<template>
    <div class="container">
        <div class="content">
            <div v-html="footerHtmlText"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, } from 'vue';
import { FooterImagesItem } from '@/view/home/supportScript';
import { useGameStore } from '@/stores/games';

const gameStore = useGameStore()
const footerHtmlText = ref('')
const groupList = computed(() => gameStore.groupList)
const props = defineProps<{
    itemData: {
        htmlText: string,
        footerImage1: FooterImagesItem,
        htmlWelcomeText: {
            display: boolean
            text: string
        },
        htmlCopywriteText: {
            display: boolean
            text: string
        }
    }
}>()
const emits = defineEmits(['openContactPopup'])
const openContactPopup = () => {
    emits('openContactPopup')
}
onMounted(() => {
    footerHtmlText.value = props.itemData.htmlText
})
</script>
<style scoped>
.container {
    padding: 5px 15px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.6);
    font-size: 16px;
    background: rgb(2, 74, 73);
    font-weight: 400;
    font-family: system-ui;
}
@media (max-width : 420px){
    .container{
       font-size: 14px; 
    }
}
</style>